/**
 * Aynı mantık ProfileSwitcher'ın içine gömülü ve export edilmiyor; oradan
 * import etmek yeni kabuğu eski bileşenin CSS import'una bağlardı.
 */

const AVATAR_COLORS = [
  "#e2001a",
  "#3a63b8",
  "#1c7a4a",
  "#9a6a12",
  "#6b4bb8",
  "#0f7b8a",
  "#b8433a",
  "#4a5468",
];

export function getInitials(name?: string | null, fallback = "?"): string {
  const trimmed = (name || "").trim();
  if (!trimmed) return fallback;

  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toLocaleUpperCase("tr");
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toLocaleUpperCase("tr");
}

/** Aynı anahtar her zaman aynı rengi verir. */
export function getAvatarColor(key?: string | null): string {
  const source = key || "";
  let hash = 0;
  for (let i = 0; i < source.length; i += 1) {
    hash = (hash * 31 + source.charCodeAt(i)) >>> 0;
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}
